import src from "IMAGE";
export default { src, width: 540, height: 540, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAS0lEQVR42q3OMQrAIBBEURNCAlEbSysPYS/aWngAG+9/Cr+gnaULb1mYLUaI06Mgd8GDDxEBL64V3kgoqGjI8OtprB8GFm7e+kzrDljhAu443DsWAAAAAElFTkSuQmCC"};
